import React from 'react';
/* APPLICATION VERSION 2.2 - NAVBAR FIX */
// This marker ensures webpack detects changes on every build
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import BrowseListings from './pages/BrowseListings';
import ListingDetail from './pages/ListingDetail';
import CreateListing from './pages/CreateListing';
import EditListing from './pages/EditListing';
import Messages from './pages/Messages';
import Profile from './pages/Profile';
import CookiePolicy from './pages/CookiePolicy';
import CookieConsentManager from './components/CookieConsentManager';
import { AuthProvider, useAuth } from './context/AuthContext';

function AppRoutes() {
  const { user } = useAuth();
  
  // Helper function to check if user is authenticated
  const isAuthenticated = !!user;
  
  console.log('AppRoutes rendering - user:', user, 'isAuthenticated:', isAuthenticated);
  
  return (
    <>
      {/* Cookie Consent Manager - GDPR & CCPA Compliance */}
      <CookieConsentManager />
      
      <div className="min-h-screen flex flex-col bg-gray-50">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/listings" element={<BrowseListings />} />
            <Route path="/listings/:id" element={<ListingDetail />} />
            <Route 
              path="/create-listing" 
              element={isAuthenticated ? <CreateListing /> : <Login redirectFrom="create-listing" />} 
            />
            <Route 
              path="/edit-listing/:id" 
              element={isAuthenticated ? <EditListing /> : <Login redirectFrom="edit-listing" />} 
            />
            <Route 
              path="/messages" 
              element={isAuthenticated ? <Messages /> : <Login redirectFrom="messages" />} 
            />
            <Route 
              path="/profile" 
              element={isAuthenticated ? <Profile /> : <Login redirectFrom="profile" />} 
            />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
          </Routes>
        </main>
        <footer className="bg-gray-800 text-white py-4">
          <div className="container mx-auto px-4 text-center">
            <p>&copy; 2026 Classifieds Platform. All rights reserved.</p>
            {/* Cookie consent notice in footer */}
            <p className="text-sm mt-2 opacity-75">
              We use cookies to improve your experience. By using our site, you agree to our 
              <a href="#" onClick={(e) => { e.preventDefault(); window.CookieConsent?.openPreferences(); }} className="underline ml-1 hover:text-secondary">Cookie Policy</a>
            </p>
          </div>
        </footer>
      </div>
    </>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </Router>
  );
}

export default App;
